// extracted by mini-css-extract-plugin
module.exports = {"list":"FeedbackOptions_list__snFQ0"};